import { z } from "zod";
import { TraceCarrierSchema } from "./trace-carrier.schema";

const UuidSchema = z.string().uuid();

/**
 * ValidateMessage — the wire format consumed by the Validate stage of the
 * async digital-asset pipeline (ADR-0045, ADV-1131). The producer side is
 * owned by ADV-1130 (Download stage), which publishes onto `media-validate`
 * after flipping `ops.media_items.processing_status` from `'downloading'` →
 * `'downloaded'`.
 *
 * Carries `import_job_id` + `business_id` on the body so the DLQ consumer
 * can call `core.decrement_pending_media_count(p_import_job_id)` without an
 * extra SELECT, and the GPS RPC can pass `business_id` without one either.
 */
export const ValidateMessageSchema = z
  .object({
    media_item_id: UuidSchema.describe("Media Item Id"),
    import_job_id: UuidSchema.describe("Import Job Id"),
    business_id: UuidSchema.describe("Business Id"),
    account_id: UuidSchema.optional().describe("Account Id"),
    // ADV-1202 / ADR-0053: W3C trace context propagated from the Download stage.
    _trace: TraceCarrierSchema.optional().describe("Trace"),
  })
  .describe("Validate Message");

export type ValidateMessage = z.infer<typeof ValidateMessageSchema>;
